export default "https://cdn-static.gokick.com/assets/b96dd49a95534624185e45ca053b90dd739d9b4e/images/choco-chill.f91442e53028d067e0a40cd80e4e8aae.png";